<ngx-ui-loader
    [fgsType]="SPINNER.ballSpinClockwise"
    [bgsType]="SPINNER.ballSpinClockwise"
    [bgsOpacity]=1
    [bgsSize]=40
    [text]="messages.locale === 'en' ? 'Loading...': 'Adatok betöltése...'">
</ngx-ui-loader>
<router-outlet></router-outlet>
